import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-96b28918"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Información General")
], -1))
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fecha"
}, "Fecha:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "especialidad"
}, "Especialidad:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "Nombre:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefonos"
}, "Teléfonos:", -1))
const _hoisted_11 = { class: "grid-consultas" }
const _hoisted_12 = { style: {"font-weight":"bold"} }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", {
          class: _normalizeClass(_ctx.isError(_ctx.error))
        }, _toDisplayString(_ctx.error), 3),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  id: "fecha",
                  type: "Date",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cxc.fecha) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cxc.fecha]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "especialidad",
                  type: "especialidad",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cxc.especialidad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cxc.especialidad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cxc.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cxc.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  id: "telefonos",
                  type: "telefonos",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cxc.telefonos) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.cxc.telefonos]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cxc.consultas, (consulta, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "card-body"
                }, [
                  _createElementVNode("p", _hoisted_12, [
                    _createTextVNode(" No. " + _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.newFormatDate(consulta.date)) + " ", 1),
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.deleteService(index)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-minus-circle redOption"
                    }, null, 8, _hoisted_13),
                    _hoisted_14,
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.editService(index, consulta)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-edit greenOption"
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(consulta.description), 1)
                ]))
              }), 128))
            ]),
            (this.modoForm == 'add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.saveCxc()), ["prevent"])),
                  disabled: 
                !_ctx.cxc.fecha ||
                  !_ctx.cxc.especialidad ||
                  !_ctx.cxc.nombre ||
                  !_ctx.cxc.telefonos
              
                }, _hoisted_19, 8, _hoisted_16))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.cxc.fecha ||
                  !_ctx.cxc.especialidad ||
                  !_ctx.cxc.nombre ||
                  !_ctx.cxc.telefonos
              
                }, _hoisted_23, 8, _hoisted_20))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}